<!-- 嵌入式-远程更新管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增远程更新
      </el-button>
      <div class="former">
        <el-select
          v-model="former.dciProductModelName"
          clearable
          placeholder="选择产品型号"
          style="width: 250px"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option> </el-select
        >&nbsp;
        <el-input
          v-model="former.key"
          placeholder="更新说明或校验条件关键字"
          @keydown.enter.native="onSubmitQuery"
          style="width: 250px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column
        prop="DciProductModelName"
        label="产品型号名称"
        width="150"
      />
      <el-table-column prop="UpdateDesc" label="更新说明" />
      <!-- <el-table-column prop="CheckCondition" label="校验条件" />
      <el-table-column
        prop="DownloadUrl"
        label="下载地址"
        width="100"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.DownloadUrl !== ''"
          >
            <div slot="content">下载地址:<br />{{ scope.row.DownloadUrl }}</div>
            <i
              class="fas fa-clone"
              style="color: #67c23a; cursor: pointer"
              v-clipboard="scope.row.DownloadUrl"
              v-clipboard:success="onSuccess"
              v-clipboard:error="onError"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onShowItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <!-- <el-button
            type="success"
            @click.stop="onDownload(scope.row)"
            title="下载"
            :disabled="scope.row.DownloadUrl === ''"
          >
            <i class="fas fa-download"></i>
          </el-button> -->
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        dciProductModelName: "",
        key: "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      modelList: [], //产品型号
    };
  },
  mounted() {
    this.getModelList();
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/remoteupdate", {
          params: {
            // where: {
            //   "UpdateDesc:like": this.former.key,
            // },
            key: this.former.key,
            dciProductModelName: this.former.dciProductModelName,
            ...this.pager,
            order: ["-created_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        // DciProductModelName: "",
        // DciProductIDs: [],
        // UpdateDesc: "",
        // Attachments: [],
        // DownloadUrl: "",
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onShowItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此远程更新信息吗？", "提示")
        .then(() => this.$axios.delete(`dci/remoteupdate/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },

    //下载
    async onDownload(row) {
      const { data } = await this.$axios({
        url: row.DownloadUrl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      // let filename = row.NewVersion;
      // if (row.NewUrl.indexOf("/") !== -1) {
      //   const arr = row.NewUrl.split("/");
      //   filename = arr[arr.length - 1];
      // }

      a.href = url;
      // a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
